<style lang="scss">
@import '../../node_modules/leaflet/dist/leaflet.css';
div#map-container {
  position: absolute;
  top: 75px;
  left: 0px;
  right: 0px;
  bottom: 0px;

  div#map {
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
  }
}
div.leaflet-top {
  z-index: 400;
}
</style>

<template>
  <div id="map-container">
    <div id="map"></div>
    <loader
      :height="60"
      :width="60"
      v-show="watercoursesLoadStatus === 1 || watercourseLoadStatus === 1"
    ></loader>
    <watercourses-search></watercourses-search>
    <map-legend></map-legend>
  </div>
</template>

<script>
import L from 'leaflet';

//Hack to display leaflet markers correctly. Kan fjernes hvis vi ikke bruker de?
/* delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
}); */

import WatercoursesSearch from './WatercoursesSearch.vue';
import router from '../router.js';
import { EventBus } from '../event-bus.js';
import Loader from './global/Loader.vue';
import MapLegend from '../components/MapLegend.vue';

export default {
  props: {
    latitude: {
      type: Number,
      default: function() {
        return 63.43;
      }
    },
    longitude: {
      type: Number,
      default: function() {
        return 10.39;
      }
    },
    zoom: {
      type: Number,
      default: function() {
        return 5;
      }
    }
  },
  components: {
    WatercoursesSearch,
    Loader,
    MapLegend
  },
  data() {
    return {
      markers: [],
      infoWindows: []
    };
  },
  mounted() {
    this.map = L.map('map', { preferCanvas: true, zoomControl: true }).setView(
      [this.latitude, this.longitude],
      this.zoom
    );
    this.map.zoomControl.setPosition('topleft');
    new L.TileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(
      this.map
    );
    new L.TileLayer(
      'https://opencache.statkart.no/gatekeeper/gk/gk.open_gmaps?layers=topo4&zoom={z}&x={x}&y={y}'
    ).addTo(this.map);
    this.markersLayer = new L.layerGroup().addTo(this.map);

    EventBus.$on(
      'location-selected',
      function(watercourse) {
        var latLng = new L.latLng(watercourse.lat, watercourse.lng);
        this.map.setZoom(16);
        this.map.panTo(latLng);
      }.bind(this)
    );

    EventBus.$on(
      'leave-watercourse',
      function(watercourse) {
        var latLng = new L.latLng(watercourse.lat, watercourse.lng);
        this.map.setZoom(watercourse.zoom);
        this.map.panTo(latLng);
      }.bind(this)
    );
  },
  computed: {
    watercourses() {
      return this.$store.getters.getWatercourses;
    },
    watercoursesLoadStatus() {
      return this.$store.getters.getWatercoursesLoadStatus;
    },
    watercourseLoadStatus() {
      return this.$store.getters.getWatercourseLoadStatus;
    }
  },
  methods: {
    buildKvalitetsnormMarkers() {
      this.markers = [];
      for (var i = 0; i < this.watercourses.length; i++) {
        var circlecolor = this.getCircleColor(this.watercourses[i].status);
        var div_circle = L.divIcon({ className: circlecolor });
        var marker = L.marker(
          [this.watercourses[i].latitude, this.watercourses[i].longitude],
          { icon: div_circle }
        ).addTo(this.markersLayer);
        marker.id = this.watercourses[i].id;
        marker.on('click', this.onClick);
        this.markers.push(marker);
      }
    },
    getCircleColor(status) {
      if (status === 1) {
        return 'circle green';
      } else if (status === 2) {
        return 'circle yellow';
      } else if (status === 3) {
        return 'circle orange';
      } else if (status === 4) {
        return 'circle red';
      } else if (status === 5) {
        return 'circle white';
      }
      return 'circle small darkgray';
    },
    
    clearMarkers() {
      this.map.removeLayer(this.markersLayer);
      this.markersLayer = new L.layerGroup().addTo(this.map);
    },
    onClick(event) {
      let store = this.$store;
      store.dispatch('applyZoomLevel', { zoomLevel: this.map.getZoom() });
      store.dispatch('applyLat', { lat: this.map.getCenter().lat });
      store.dispatch('applyLng', { lng: this.map.getCenter().lng });
      this.$store.dispatch('loadWatercourse', { id: event.target.id });
      router.push({ name: 'watercourse', params: { id: event.target.id } });
    }
  },
  watch: {
    watercourses() {
      this.clearMarkers();
      this.buildKvalitetsnormMarkers();
    },
    watercoursesLoadStatus: function(newValue) {
      if (newValue == 3) {
        EventBus.$emit('show-error', {
          notification: 'Klarte ikke å hente vassdragene'
        });
        this.$router.push({ name: 'watercourses' });
      }
    }
  }
};
</script>
